import { useState } from "react";
import { seller_from_ngo } from "../../reduxData/user/userAction";
import "./SellerNGO.css";

const StatusIcon = ({ status }) => {
  if (status === "approved")
    return (
      <svg
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
        <polyline points="22 4 12 14.01 9 11.01" />
      </svg>
    );
  if (status === "rejected")
    return (
      <svg
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="12" cy="12" r="10" />
        <line x1="15" y1="9" x2="9" y2="15" />
        <line x1="9" y1="9" x2="15" y2="15" />
      </svg>
    );
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="10" />
      <polyline points="12 6 12 12 16 14" />
    </svg>
  );
};

const ChevronIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="6 9 12 15 18 9" />
  </svg>
);

const SellerNGO = ({
  isNGOSeller,
  setIsNGOSeller,
  brands,
  category,
  setSelectNGOAttributes,
  selectNGOAttributes,
  fetchData,
  id,
  seller,
  editBrand,
  setAllowBrand,
  allowEditBrand,
}) => {
  const [loading, setLoading] = useState(false);
  console.log("allowEditBrand", allowEditBrand);

  const getEditBrandPayload = (val) => {
    const editData = brands?.find(
      (i) => i?.id == selectNGOAttributes?.brand_id
    );
    const brandPayload = {
      ...editData,
      is_community_brand: selectNGOAttributes?.is_community_brand ?? false,
    };
    if (val) {
      brandPayload.is_community_brand = val;
    }
    return brandPayload;
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);

      const ngoPayload = {
        community_seller_status: isNGOSeller ? "approved" : "rejected",
        brand_id: Number(selectNGOAttributes?.brand_id || 0),
        // product_type_id: Number(selectNGOAttributes?.product_type_id || 0),
      };

      const [ngoRes] = await Promise.all([seller_from_ngo(ngoPayload, id)]);

      if (ngoRes) {
        fetchData();
      }
    } finally {
      setLoading(false);
    }
  };

  const ToggleSeller = async (val) => {
    const ngoPayload = {
      community_seller_status: val ? "approved" : "rejected",
      brand_id: seller?.brand_id,
    };
    const res = await seller_from_ngo(ngoPayload, id);
    if (res) {
      fetchData();
    }
  };

  const deActivate = async (val) => {
    const payload = {
      community_seller_status: val,
      brand_id: seller?.brand_id,
      product_type_id: seller?.product_type_id,
    };
    const res = await seller_from_ngo(payload, id);
    if (res) {
      fetchData();
    }
  };

  const isPending = seller?.community_seller_status === "pending";
  const isApproved = seller?.community_seller_status === "approved";
  const isRejected = seller?.community_seller_status === "rejected";
  const isDeactived = seller?.community_seller_status === "deactivated";

  const statusConfig = {
    approved: {
      label: "Approved",
      bg: "#f0fdf4",
      color: "#15803d",
      border: "#bbf7d0",
    },
    rejected: {
      label: "Rejected",
      bg: "#fef2f2",
      color: "#dc2626",
      border: "#fecaca",
    },
  };

  const currentStatus = seller?.community_seller_status || "pending";
  const isCommunityBrand = brands?.find((i) => i?.id == seller?.brand_id);
  console.log("isCommunityBrand", isCommunityBrand);
  const filterBrands = brands?.filter((i) => i?.is_community_brand);
  return (
    <div className="col-lg-6">
      <div className="ngo-card">
        {/* Header */}
        <div className="ngo-card-header">
          <div className="ngo-header-left">
            <div className="ngo-icon-wrap">
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                <polyline points="9 22 9 12 15 12 15 22" />
              </svg>
            </div>
            <h6 className="ngo-title">Community Seller </h6>
          </div>

          <div className="ngo-community-row">
            <label className="ngo-switch">
              <input
                type="checkbox"
                checked={isNGOSeller}
                onChange={(e) => {
                  setIsNGOSeller(e.target.checked);
                  ToggleSeller(e.target.checked);
                }}
              />
              <span className="ngo-slider"></span>
            </label>
          </div>

          {/* {["approved", "rejected", "deactivated"].includes(
            seller?.community_seller_status
          ) && (
            <span
              className={`cursor-pointer ngo-status-pill ${
                seller?.community_seller_status == "deactivated"
                  ? "bg-success"
                  : "bg-danger"
              }  text-white`}
              onClick={()=>{
                if(seller?.community_seller_status == "deactivated")
                deActivate("approved")
              else
                deActivate("deactivated")
              }}
            >
              {seller?.community_seller_status == "deactivated"
                ? "Activate"
                : "Deactivate"}
            </span>
          )} */}
        </div>

        {/* Body */}

        <div className="ngo-card-body">
          {isNGOSeller && (
            <>
              <p className="ngo-desc">
                This seller is authorized to list and sell products on behalf of
                an NGO.
              </p>
              <div className="ngo-divider" />
              <div>
                <p className="ngo-approval-label" style={{ marginBottom: 10 }}>
                  Assigned attributes
                </p>
                <div className="">
                  <div className="ngo-info-cell d-flex justify-content-between align-items-center">
                    {!allowEditBrand ? (
                      <div className="ngo-select-wrap">
                        <select
                          className="ngo-select"
                          defaultValue=""
                          onChange={(e) => {
                            const selectedBrand = brands?.find(
                              (b) => b.id == e.target.value
                            );

                            setSelectNGOAttributes((prev) => ({
                              ...prev,
                              brand_id: e.target.value,
                              is_community_brand:
                                selectedBrand?.is_community_brand || false,
                            }));
                          }}
                        >
                          <option value="" disabled>
                            Select a brand
                          </option>
                          {filterBrands?.map((i, idx) => (
                            <option value={i?.id} key={`${i?.id}_${idx}`}>
                              {i?.brand_name}
                            </option>
                          ))}
                        </select>
                        <span className="ngo-select-icon">
                          <ChevronIcon />
                        </span>
                      </div>
                    ) : (
                      <div>
                        <div className="ngo-info-cell-label">Brand</div>
                        <div className="ngo-info-cell-val">
                          {brands?.find((b) => b.id === seller?.brand_id)
                            ?.brand_name || "—"}
                        </div>
                      </div>
                    )}
                    {allowEditBrand && (
                      <button
                        className="btn btn-primary my-2"
                        onClick={() => setAllowBrand(!allowEditBrand)}
                      >
                        Edit
                      </button>
                    )}
                    {!allowEditBrand && (
                      <button
                        className="btn btn-success"
                        disabled={!selectNGOAttributes?.brand_id}
                        onClick={() => handleSubmit()}
                      >
                        Save
                      </button>
                    )}
                  </div>
                  {/* <div className="ngo-info-cell">
                      <div className="ngo-info-cell-label">Category</div>
                      <div className="ngo-info-cell-val">
                        {category?.find((c) => c.id === seller?.product_type_id)
                          ?.type_name || "—"}
                      </div>
                    </div> */}
                </div>
              </div>
            </>
          )}

          {/* {isRejected && (
              <>
                <div className="ngo-rejected-banner">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle cx="12" cy="12" r="10" />
                    <line x1="12" y1="8" x2="12" y2="12" />
                    <line x1="12" y1="16" x2="12.01" y2="16" />
                  </svg>
                  This seller is not authorized to sell products on behalf of an
                  NGO.
                </div>
              </>
            )} */}

          {/* {isDeactived && <div className="text-danger">Deactivated</div>} */}
        </div>
      </div>
    </div>
  );
};

export default SellerNGO;
